const STORAGE_KEY = "fab-leads-return-context";
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export type LeadsReturnContext = {
  workspaceId: string;
  funnelId: string;
  stageSlug: string | null;
  timestamp: number;
};

export function saveLeadsReturnContext(
  ctx: Omit<LeadsReturnContext, "timestamp">,
): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...ctx, timestamp: Date.now() }),
    );
  } catch {
    // ignore quota / private mode
  }
}

export function consumeLeadsReturnContext(
  workspaceId: string,
): LeadsReturnContext | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as LeadsReturnContext;
    if (parsed.workspaceId !== workspaceId) return null;
    if (Date.now() - parsed.timestamp > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    return parsed;
  } catch {
    return null;
  }
}

export function buildLeadsKanbanUrl(funnelId: string, stageSlug?: string | null): string {
  const params = new URLSearchParams();
  params.set("funnel_id", funnelId);
  if (stageSlug) params.set("stage", stageSlug);
  return `/leads?${params.toString()}`;
}
